const STRINGS = {
  requiredErrorMessage: "Select an option to continue."
};
export default STRINGS;